import { css, Theme } from '@emotion/react'
import { buttonBaseClasses } from '@mui/material'

export const label = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
`

export const error = (theme: Theme) => css`
  color: ${theme.colors.red};
  margin-top: 8px;
`

export const tabsRow = css`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
`

export const tabContent = (isVisible?: boolean) => css`
  display: ${isVisible ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
`

export const columns = css`
  display: flex;
  gap: 24px;
`

export const passageHeader = css`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`

export const iconButton = css`
  margin-top: 29px;

  &.${buttonBaseClasses.root} {
    height: 40px;
    width: 40px;
    min-width: 40px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`

export const addButton = css`
  flex-shrink: 0;
`
